<div class="d-flex flex-row">
  <!-- in `let star of stars` star is only for iterating, not for usage -->
  <mat-icon
    class="star d-flex align-items-center justify-content-center"
    *ngFor="let star of stars; index as i"
    [style]="
      'font-size: ' + starSize + 'px;' +
      'height: ' + starSize + 'px;' +
      'width: ' + starSize + 'px;'
    "
    [ngClass]="{ 'filled': i < rating, 'empty': i >= rating, 'cursor-pointer': isEditable }"
    (click)="setRating(i + 1)"
  >
    star
  </mat-icon>
</div>
